import React from 'react';

/**
 * How to connect Instagram: two paths, different metrics.
 *
 * Instagram exposes per-post reach, impressions and saves — and Story
 * insights — only to a Facebook Page token. An Instagram-Login token reaches
 * followers, media and a narrower insights set. Asking here is better than
 * connecting the thin way and explaining the empty columns afterwards.
 *
 * Both options connect INSTAGRAM. Facebook is only who authorises the first
 * one, so it is named for what it gives you, not for the provider — this
 * screen also offers "connect a Facebook Page", which is a different feature,
 * and a button labelled "Facebook" here would read as that.
 */
const InstagramConnectChooser = ({ open, onChooseFull, onChooseBasic, onClose }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 px-4">
      <div className="bg-surface rounded-xl max-w-lg w-full p-6">
        <div className="flex items-start justify-between mb-1">
          <h3 className="text-xl font-bold text-ink">Connect Instagram</h3>
          <button
            onClick={onClose}
            className="text-ink-muted hover:text-ink text-lg leading-none"
            aria-label="Close"
          >✕</button>
        </div>
        <p className="text-sm text-ink-muted mb-5">
          Two ways to connect. They differ in which analytics Instagram will
          give us.
        </p>

        <button
          onClick={onChooseFull}
          className="w-full text-left border-2 border-ink rounded-xl p-4 mb-3 hover:bg-canvas transition"
        >
          <div className="flex items-center gap-2 mb-1">
            <span className="font-semibold text-ink">Full analytics</span>
            <span className="text-[10px] uppercase tracking-wide bg-accent text-accent-ink px-2 py-0.5 rounded">
              Recommended
            </span>
          </div>
          <p className="text-sm text-ink-body leading-relaxed">
            Everything below, plus <strong>per-post reach, impressions and
            saves</strong>, and Story insights. Needed for breakout scores that
            account for how far a post travelled.
          </p>
          <p className="text-xs text-ink-muted mt-2 leading-relaxed">
            Requires a Business or Creator account linked to a Facebook Page you
            manage. You will approve the connection on Facebook — your Instagram
            account is what gets connected.
          </p>
        </button>

        <button
          onClick={onChooseBasic}
          className="w-full text-left border border-line rounded-xl p-4 hover:border-line-strong transition"
        >
          <div className="font-semibold text-ink mb-1">Basic analytics</div>
          <p className="text-sm text-ink-body leading-relaxed">
            Followers, posts, likes and comments. <strong>No per-post reach,
            impressions or saves.</strong>
          </p>
          <p className="text-xs text-ink-muted mt-2 leading-relaxed">
            Works with any Instagram account. You can switch to full analytics
            later without reconnecting.
          </p>
        </button>
      </div>
    </div>
  );
};

export default InstagramConnectChooser;
